export default __webpack_public_path__ + "static/image18-c02ef239cfbcb88687002e4e726529c2.jpg";